<template>
    <div v-if="options.length > 0">
        <p class="bsdc-config-filters__label">
            {{ label }}

            <Tooltip :text="tooltip" />

            <slot name="label" />
        </p>

        <div class="bsdc-config-selector">
            <label
                v-for="(option, index) in options"
                :key="index"
                :for="`${name}-filter-${option.value}`"
                class="bsdc-config-selector__item"
                :class="{
                    active: selectedOptionsSafe.includes(option.value),
                    'bsdc-config-selector__item--color': colored,
                    'bsdc-config-selector__item--blue': option.value === 'Blue',
                    'bsdc-config-selector__item--green': option.value === 'Green',
                    'bsdc-config-selector__item--red': option.value === 'Red',
                    'bsdc-config-selector__item--teal': option.value === 'Teal',
                    'bsdc-config-selector__item--pink': option.value === 'Pink',
                    'bsdc-config-selector__item--purple': option.value === 'Purple',
                    'bsdc-config-selector__item--yellow': option.value === 'Yellow',
                    'bsdc-config-selector__item--violet': option.value === 'Violet',
                    'bsdc-config-selector__item--brown': option.value === 'Brown',
                    'bsdc-config-selector__item--orange': option.value === 'Orange',
                    'bsdc-config-selector__item--grey': option.value === 'Grey',
                    'bsdc-config-selector__item--white': option.value === 'White',
                    'bsdc-config-selector__item--black': option.value === 'Black',
                    'bsdc-config-selector__item--other': option.value === 'Other',
                }"
            >
                {{ option.label }}

                <input
                    :id="`${name}-filter-${option.value}`"
                    type="checkbox"
                    :value="option.value"
                    :checked="localSelectedOptions.includes(option.value)"
                    @change="handleCheckboxChange($event)"
                />
            </label>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';

    import Tooltip from "@js/Components/Tooltip.vue";

    const props = defineProps({
        label: String,
        name: String,
        tooltip: String,
        colored: Boolean,
        options: {
            type: Array,
            default: () => []
        },
        selectedOptions: {
            type: Array,
            default: () => []
        },
    });

    const emit = defineEmits(["update:selectedOptions"]);

    const selectedOptionsSafe = computed(() => Array.isArray(props.selectedOptions) ? props.selectedOptions : []);

    const localSelectedOptions = ref([...selectedOptionsSafe.value]);

    watch(() => props.selectedOptions, (newVal) => {
        localSelectedOptions.value = Array.isArray(newVal) ? [...newVal] : [];
    });

    function handleCheckboxChange(event) {
        if (event.target.checked) {
            localSelectedOptions.value.push(event.target.value);
        } else {
            localSelectedOptions.value = localSelectedOptions.value.filter(
                (c) => c !== event.target.value
            );
        }

        emit("update:selectedOptions", localSelectedOptions.value);
    }
</script>
